import React from "react";

import {
  BrowserRouter as Router, 
  Route,
  Routes
} from "react-router-dom";

import {
  landing as landingRoutes,
  dashboard as dashboardRoutes,
  operations as operationsRoutes,
} from "./routeDefinition";

import DashboardLayout from "../layouts/Dashboard";
import AuthLayout from "../layouts/Auth";
import Page404 from "../pages/auth/Page404";
import ScrollToTop from "../components/ScrollToTop";
import AuthRoute from "../components/AuthRoute";

const trace = (path, index) => {
  return path + '-' + index;
}

/**
 * 
 * @param {*} Layout 
 * @param {*} routes 
 * @returns 
 */
const childRoutes = (Layout, routes) => {

  return routes.map(({ children, name, path, component: Component }, index) =>
    children ? (
      // Route item with children
      children.map(({ name, path, component: Component }, index) => (
        <Route
          key={path+index}
          path={path}
          exact
          element={ 
            <Layout title={name}>
              <AuthRoute>
                <Component />
              </AuthRoute>                
            </Layout>
          }
        />
      ))
    ) : (
      // Route item without children
      <Route
      key={path+index}
        path={path}
        exact
        element={
          <Layout>
              <AuthRoute>
                <Component />
              </AuthRoute>          
          </Layout>
        }
      />
    )
  )};

/**
 * 
 * @returns 
 */
const TanseeqWebRoutes = () => {  



  return (
      <AuthRoute>
        <Router future={{ v7_startTransition: true }}>
         <ScrollToTop>
            <Routes>
                {childRoutes(DashboardLayout, landingRoutes)}
                {childRoutes(DashboardLayout, operationsRoutes)}
                <Route element={<AuthLayout> <Page404 /> </AuthLayout>} />
            </Routes>
          </ScrollToTop>
        </Router>
      </AuthRoute>
    );
}

export default TanseeqWebRoutes;

